<template>
    <div>
        
        <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="6">
                        Preguntas, sub preguntas y respuestas
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <v-btn
                            color=""
                            dark
                            class="mb-2 float-right bg-light-blue"
                            
                            @click="modalNueva(1,0)"
                        >
                            Agregar pregunta
                        </v-btn>
                    </v-col> 
            
                </v-row>
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>
                        
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                        <v-select
                            v-model="indiceSeleccionadoId"
                            :items="indices"
                            :loading="ddIndicesLoading"
                            dense
                            outlined
                            label="Seleccionar Índice"
                            item-text="nombreIndice"
                            item-value="id"
                            menu-props="auto"
                            :no-data-text="indices ? 'Selecciona un índice' : 'No se han registrado índices'"
                            @change="obtenerPreguntasPorIndice"
                        ></v-select>
                    </v-col>
                </v-row>

                <v-data-table
                    :items="preguntas"
                    item-key="id"
                    class="elevation-0 mt-4"
                    :loading="tableLoading"
                    :no-data-text="tableNoDataText"
                    :items-per-page="10"
                    dense
                    :footer-props="{
                        showFirstLastPage: true,
                        firstIcon: 'mdi-page-first',
                        lastIcon: 'mdi-page-last',
                        prevIcon: 'mdi-chevron-left',
                        nextIcon: 'mdi-chevron-right',
                        'items-per-page-text':'Registros por página',
                        pageText: '{0}-{1} de {2}' 
                    }"
                >
                    <template v-slot:item="{ item }">
                        <tr @click="handleClick(item)">
                            <!--<td>{{ item.id }} :class="item.preguntasId != ? 'text-right' : ''">{{ item.preguntasId ? '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' : '' }}</td>-->
                            <td>{{ item.textoPregunta }}</td>
                            <td>
                                <v-chip
                                        class="ma-2"
                                        :color="item.estadosId === 1 ? 'teal' : item.estadosId ===2 ? 'red' : item.estadosId ===3 ? 'blue' : 'red' "
                                        text-color="white"
                                        small
                                    >
                                        {{item.estado}}
                                </v-chip>
                            </td>
                            <td>
                                <v-btn class="ma-1 text-capitalize text-subtitle-2" small tile outlined color="indigo" @click="obtenerDatosPregunta(item.id,1)">
                                    <v-icon left>mdi-cogs</v-icon> Configurar
                                </v-btn>
                                <v-btn class="ma-1 text-capitalize text-subtitle-2" small tile outlined color="indigo" @click="modalNueva(2,item.id, item.institucionesId, item.indicesId)">
                                    <v-icon left>mdi-plus</v-icon> Sub pregunta
                                </v-btn>
                                
                                <!--
                                <v-btn class="ma-1 text-capitalize" small tile outlined color="indigo" @click="modalRespuestas(item.textoPregunta, item.id)">
                                    <v-icon left>mdi-plus</v-icon> Respuestas
                                </v-btn>
                                <v-btn v-if="item.preguntasId =! null" class="ma-1 text-capitalize" small tile outlined color="indigo" @click="modalMediosVerificacion(item.textoPregunta, item.id)">
                                    <v-icon left>mdi-plus</v-icon> M.V.
                                </v-btn>
                                
                                
                                <v-btn class="ma-1 text-capitalize" small tile outlined color="indigo" @click="agregarRespuesta(item.id)">
                                    <v-icon left>mdi-plus</v-icon> Respuestas
                                </v-btn>-->
                                

                            </td>
                        </tr>
                        <tr div v-for="subpregunta in item.subPreguntas" :key="subpregunta.id">

                            
                                <td>
                                    <v-row>
                                        <v-col md="1" sm="1" xs="1"></v-col>
                                        <v-col md="11" sm="11" xs="11">{{ subpregunta.textoPregunta }} </v-col>
                                    </v-row>
                                </td>
                                <td>
                                <v-chip
                                        class="ma-2"
                                        :color="subpregunta.estadosId === 1 ? 'teal' : subpregunta.estadosId ===2 ? 'red' : subpregunta.estadosId ===3 ? 'blue' : 'red' "
                                        text-color="white"
                                        small
                                    >
                                        {{subpregunta.estado}}
                                </v-chip>
                            </td>
                            <td>
                                <v-btn class="ma-1 text-capitalize text-subtitle-2" small tile outlined color="indigo" @click="obtenerDatosPregunta(subpregunta.id,2)">
                                    <v-icon left>mdi-cogs</v-icon> Configurar
                                </v-btn>
                                
                                <!--
                                <v-btn class="ma-1 text-capitalize" small tile outlined color="indigo" @click="modalRespuestas(subpregunta.textoPregunta, subpregunta.id)">
                                    <v-icon left>mdi-plus</v-icon> Respuestas
                                </v-btn>
                                
                                <v-btn class="ma-1 text-capitalize" small tile outlined color="indigo" @click="modalNueva(2,subpregunta.id, subpregunta.institucionesId, subpregunta.indicesId)">
                                    <v-icon left>mdi-plus</v-icon> Sub pregunta
                                </v-btn>
                                
                                <v-btn class="ma-1 text-capitalize" small tile outlined color="indigo" @click="agregarRespuesta(item.id)">
                                    <v-icon left>mdi-plus</v-icon> Respuestas
                                </v-btn>-->
                                

                            </td>
                            

                        </tr>

                    </template>

                    

                    
                    

                </v-data-table>

            </v-card-text>
        </v-card>
        




    <!-- Inicio:: Dialog para mostrar los datos de la puesto-->
    <v-dialog
        v-model="dialog"
        fullscreen 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                {{modalTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
                <v-card-text>

                    <v-tabs v-model="activeTab">
                        <v-tab :key="1">
                            <v-icon left>
                            mdi-file-document-edit-outline
                            </v-icon>
                            Datos Principales
                        </v-tab>
                        <v-tab :disabled="accion===1" :key="2">
                            <v-icon left>
                            mdi-forum
                            </v-icon>
                            Respuestas
                        </v-tab>
                        <v-tab :disabled="accion===1 || tabMediosDisabled" :key="3">
                            <v-icon left>
                            mdi-file
                            </v-icon>
                            Medios de verificación
                        </v-tab>

                    <v-tab-item>
                         
                        <v-card>
                            <v-form
                                ref="form"
                                v-on:submit.prevent="registrarItem"
                                v-model="validForm"
                                >
                                <v-card-text>
                                    
                                    <v-row v-if="subPregunta==true">
                                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                                            <v-select
                                                v-model="datosPregunta.preguntasId"
                                                :items="preguntasSuperiores"
                                                :disabled="true"
                                                dense
                                                outlined
                                                label="Pregunta Superior"
                                                item-text="textoPregunta"
                                                item-value="id"
                                                :no-data-text="preguntas ? 'Selecciona una pregunta' : 'No se han registrado preguntas'"
                                            ></v-select>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                                            <v-select
                                                outlined
                                                autocomplete="off"
                                                class="required"
                                                dense
                                                :disabled="subPregunta"
                                                :items="indices"
                                                v-model="datosPregunta.indicesId"
                                                label="Seleccionar índice"
                                                item-text="nombreIndice"
                                                item-value="id"
                                                :rules="[
                                                    selectRequired(
                                                        'Índice'
                                                    )
                                                ]"
                                                menu-props="auto"
                                                maxlength="100"
                                            ></v-select>
                                        </v-col>

                                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                                            <v-select
                                                v-model="datosPregunta.institucionesId"
                                                :items="instituciones"
                                                :loading="ddInstitucionesLoading"
                                                :disabled="subPregunta"
                                                dense
                                                outlined
                                                label="Institución revisora"
                                                item-text="nombreInstitucion"
                                                item-value="id"
                                                menu-props="auto"
                                            ></v-select>
                                        </v-col>
                                        
                                    </v-row>

                                    <v-row>
                                        
                                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                                            <v-text-field
                                                outlined
                                                autocomplete="off"
                                                class="required"
                                                dense
                                                v-model="datosPregunta.textoPregunta"
                                                label="Texto de la pregunta"
                                                :rules="[
                                                    required(
                                                        'Nombre del índice'
                                                    ),
                                                    maxLength('Nombre del índice', 255),
                                                    minLength('Nombre del índice', 3)
                                                ]"
                                                maxlength="255"
                                            ></v-text-field>
                                        </v-col>
                                        
                                    </v-row>

                                    <v-row>

                                        <v-col cols="12" md="6" sm="6" xs="12" class="pt-1 pb-1">
                                            <v-select
                                                v-model="datosPregunta.obligatoria"
                                                :items="obligatoriaValores"
                                                :loading="ddInstitucionesLoading"
                                                dense
                                                outlined
                                                label="¿Es Obligatoria?"
                                                item-text="obligatoria"
                                                item-value="id"
                                                maxlength="2"
                                            ></v-select>
                                        </v-col>

                                        



                                    </v-row>

                                    <v-row>
                                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                                            <v-textarea
                                                outlined
                                                counter="1000"
                                                autocomplete="off"
                                                :class="!subPregunta ? 'required' : ''"
                                                dense
                                                rows="7"
                                                v-model="datosPregunta.descripcion"
                                                label="Descripción de la pregunta"
                                                :rules="[
                                                    !subPregunta ? required('Descripción de la pregunta') : true,
                                                    maxLength('Descripción de la pregunta', 1000),
                                                    !subPregunta ? minLength('Descripción de la pregunta', 3) : true
                                                ]"
                                                maxlength="1000"
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>

                                    <!--<v-row>
                                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                                            <v-textarea
                                                outlined
                                                autocomplete="off"
                                                class="required"
                                                dense
                                                rows="3"
                                                v-model="datosPregunta.textoAyudaPregunta"
                                                label="Texto de ayuda de la pregunta"
                                                :rules="[
                                                    required(
                                                        'Texto de ayuda de la pregunta'),
                                                    maxLength('Texto de ayuda de la pregunta', 500),
                                                    minLength('Texto de ayuda de la pregunta', 5)
                                                ]"
                                                hint="Agregue un texto que guiará al informador para responder la pregunta"
                                                maxlength="255"
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>-->


                                    

                                    <v-row>
                                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                                            <label class="grey--text body-2">Estado</label>
                                            <template>
                                                <v-switch
                                                    v-model="switchItemEstado"
                                                    inset
                                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                                    >
                                                </v-switch>
                                            </template>
                                        </v-col>
                                    </v-row>

                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                
                                    <v-btn
                                        color="grey lighten-5"
                                        elevation="0"
                                        class="mb-2 float-right grey lighten-5"
                                        @click="dialog = false; resetForm()"
                                        :disabled="btnRegistroLoading"
                                    >
                                        Cancelar
                                    </v-btn>
                                    <!--:disabled="!validDocForm" type="submit"-->
                                    <v-btn
                                        color="primary"
                                        class="mb-2 float-right"
                                        type="submit"
                                        :elevation="0" 
                                        :disabled="!validForm" 
                                        :loading="btnRegistroLoading"                         
                                    >
                                        {{btnRegistroText}}
                                    </v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card color="basil" flat>
                            <v-card-text class="pt-0">
                                <AdminRespuestas
                                        :idPregunta="idPregunta"
                                        :idIndice="indiceSeleccionadoId"
                                        :key="adminRespuestaKey"

                                    />
                            </v-card-text>
                        </v-card>
                        
                    </v-tab-item>

                    <v-tab-item :disabled="accion===1 || tabMediosDisabled">
                        <v-card color="basil" flat>
                            <v-card-text class="pt-0">
                                <AdminMediosVerificacion
                                        :idPregunta="idPregunta"
                                        :key="adminMediosKey"

                                    />
                            </v-card-text>
                        </v-card>
                        
                    </v-tab-item>
                </v-tabs>  
            </v-card-text>
                
            
        </v-card>
    </v-dialog>


    <!-- Fin:: Dialog para mostrar los datos de la puesto-->




     <!-- Inicio:: Dialog para ingresar las respuestas de la pregunta-->
    <v-dialog
        v-model="dialogRes"
        max-width="900px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                Respuestas | Cuantos cocodes están regisrados
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialogRes = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            
                <v-card-text>
                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                            <v-select
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                :items="tiposRespuesta"
                                v-model="datosPregunta.preguntasId"
                                label="Tipo de respuesta"
                                item-text="tipo"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'Pregunta superior'
                                    )
                                ]"
                                maxlength="100"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                    
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosPregunta.textoPregunta"
                                label="Texto de la respuesta"
                                :rules="[
                                    required(
                                        'Nombre del índice'
                                    ),
                                    maxLength('Nombre del índice', 255),
                                    minLength('Nombre del índice', 5)
                                ]"
                                maxlength="255"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                     <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                            <v-select
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                :items="tiposValidacion"
                                v-model="datosPregunta.preguntasId"
                                label="Seleccionar validación"
                                item-text="nombre"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'Pregunta superior'
                                    )
                                ]"
                                maxlength="100"
                            ></v-select>
                        </v-col>
                    </v-row>


                    <v-row>
                        <template>
                            <v-simple-table>
                                <template v-slot:default>
                                <thead>
                                    <tr>
                                    <th class="text-left">
                                        Tipo Validación
                                    </th>
                                    <th class="text-left">
                                        Definición
                                    </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                    <td>Rango</td>
                                    <td>Números entre 0 y 12</td>
                                    </tr>
                                </tbody>
                                </template>
                            </v-simple-table>
                            </template>
                    </v-row>

                     <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                             <template>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                             </template>
                        </v-col>
                    </v-row>
                    
                </v-card-text>

                 <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialogRes = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="!validForm" 
                                :loading="btnRegistroLoading"                         
                            >
                                {{btnRegistroRespuesta}}
                            </v-btn>
                </v-card-actions>
                    
        </v-card>
    </v-dialog>
    <!-- Fin:: Dialog para ingresar las respuestas de la pregunta-->

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import validations from "@/core/untils/validations.js";
import { OBTENER_INDICES } from "@/core/services/store/catalogos/indice.module";
import { OBTENER_PREGUNTAS_POR_INDICE, OBTENER_PREGUNTAS, OBTENER_PREGUNTA, REGISTRAR_PREGUNTA, ACTUALIZAR_PREGUNTA } from "@/core/services/store/pregunta.module";
import { OBTENER_SUB_PREGUNTAS_POR_PREGUNTA } from "@/core/services/store/preguntas/subpregunta.module";
import { OBTENER_INSTITUCIONES } from "@/core/services/store/institucion.module";

import AdminRespuestas from '@/view/pages/admin/preguntas/respuestas/AdminRespuestas.vue';
import AdminMediosVerificacion from '@/view/pages/admin/preguntas/medios/AdminMediosVerificacion.vue';


import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";
  const avatars = [
    '?accessoriesType=Blank&avatarStyle=Circle&clotheColor=PastelGreen&clotheType=ShirtScoopNeck&eyeType=Wink&eyebrowType=UnibrowNatural&facialHairColor=Black&facialHairType=MoustacheMagnum&hairColor=Platinum&mouthType=Concerned&skinColor=Tanned&topType=Turban',
    '?accessoriesType=Sunglasses&avatarStyle=Circle&clotheColor=Gray02&clotheType=ShirtScoopNeck&eyeType=EyeRoll&eyebrowType=RaisedExcited&facialHairColor=Red&facialHairType=BeardMagestic&hairColor=Red&hatColor=White&mouthType=Twinkle&skinColor=DarkBrown&topType=LongHairBun',
    '?accessoriesType=Prescription02&avatarStyle=Circle&clotheColor=Black&clotheType=ShirtVNeck&eyeType=Surprised&eyebrowType=Angry&facialHairColor=Blonde&facialHairType=Blank&hairColor=Blonde&hatColor=PastelOrange&mouthType=Smile&skinColor=Black&topType=LongHairNotTooLong',
    '?accessoriesType=Round&avatarStyle=Circle&clotheColor=PastelOrange&clotheType=Overall&eyeType=Close&eyebrowType=AngryNatural&facialHairColor=Blonde&facialHairType=Blank&graphicType=Pizza&hairColor=Black&hatColor=PastelBlue&mouthType=Serious&skinColor=Light&topType=LongHairBigHair',
    '?accessoriesType=Kurt&avatarStyle=Circle&clotheColor=Gray01&clotheType=BlazerShirt&eyeType=Surprised&eyebrowType=Default&facialHairColor=Red&facialHairType=Blank&graphicType=Selena&hairColor=Red&hatColor=Blue02&mouthType=Twinkle&skinColor=Pale&topType=LongHairCurly',
  ]

  const pause = ms => new Promise(resolve => setTimeout(resolve, ms))

  export default {
      components: {
        SnackAlert,
        DialogLoader,
        AdminRespuestas,
        AdminMediosVerificacion,

        },
    data: () => ({
      adminRespuestaKey:0,
      adminMediosKey:0,
      tableLoading: false,
      tableNoDataText: 'No hay preguntas para mostrar',
      dialog: false,
      accion: 1,
      dialogRes: false,
      activeTab: 0,
      tabMediosDisabled:false,
      validForm:false,
      modalTitle:'Agregar Pregunta',
      btnRegistroLoading: false,
      btnRegistroText: 'Agregar Pregunta',
      btnRegistroRespuesta: 'Agregar Respuesta',
      dialogLoaderVisible: false,
      dialogLoaderText:'Obteniendo información...',
      ddIndicesLoading:false,
      ddInstitucionesLoading: false,
      indices: [],
      instituciones:[],
      tiposRespuesta: [{id: 1, tipo:'Número'}, {id:2, tipo: 'Texto'}],
      tiposValidacion: [{id: 1, nombre:'Rango'}, {id:2, nombre: 'Numero mayor que'}],
      obligatoriaValores: [{id: 'Si', obligatoria: 'Si'}, {id: 'No', obligatoria: 'No'}],
      indiceSeleccionadoId:0,
      idPregunta:0,
      datosPregunta:{
          preguntasId:0,
          indicesId:0,
          visitaCampo:'',
          textoAyudaPregunta:'',
          descripcion:'',
          textoPregunta:'',
          estadosId: 1,
          institucionesId:0,
          obligatoria:'No',
          longitudMaxima:0,
          longitudMinima: 0,
      },
      switchItemEstado: false,
      active: [],
      avatar: null,
      open: [],

      indiceSeleccinadoId: 1,
      preguntas: [],
      preguntasSuperiores:[],
      subpreguntas:[],
      users: [],
      renderAdminRespuestas:false,
      subPregunta:false,
      preguntaPadreId:0,
      ...validations
    }),

    watch: {
      selected: 'randomAvatar',
    },

    methods: {

        resetForm(){
           // this.$refs.form.reset();
            this.activeTab=0;
            this.datosPregunta={
            preguntasId:0,
            indicesId:0,
            visitaCampo:'',
            textoAyudaPregunta:'',
            descripcion: '',
            textoPregunta:'',
            estadosId: 1,
            institucionesId:0,
            obligatoria:'No',
            longitudMaxima:0,
            longitudMinima: 0

        },
            this.subPregunta=false;

            this.switchItemEstado = true;
            //console.log(this.switchItemEstado)
        },

        async obtenerIndices(){
            this.indices=[];
            this.ddIndicesLoading=true;
            await this.$store
            .dispatch(OBTENER_INDICES, 1)
            .then(res => {
                if(res.status===200){
                    this.indices=res.data;
                } else {
                    console.warn(res.message)
                }
                this.ddIndicesLoading=false;
               
            }
            )
            .catch(() => {
                this.ddIndicesLoading=false;
                //console.warn(err)
            });


        },

        //!Obtener las institucines revisoras
        async obtenerInstitucionesRevisoras(){
            this.instituciones=[];
            this.ddInstitucionesLoading=true;

            this.$store
            .dispatch(OBTENER_INSTITUCIONES)
            .then(() => {
                this.instituciones = this.$store.state.institucion.instituciones;
                //console.log(this.items)
                //console.log(this.items)
                this.ddInstitucionesLoading=false;
            })
            .catch(() => {
                this.ddInstitucionesLoading=false;
            });   
        },
      
      //!Obtener el listado de preguntas por índice (estructura por subpreguntas)
      async obtenerPreguntasPorIndice(){
          this.tableLoading=true;
          this.preguntas=[];
            await this.$store
            .dispatch(OBTENER_PREGUNTAS_POR_INDICE, {indiceId:this.indiceSeleccionadoId})
            .then(res => {
                //console.log(res)
                if(res.status===200){
                    this.preguntas = res.data;
                } else {
                    //console.warn(res.message)
                    this.tableNoDataText = 'No se encontraron preguntas para el índice seleccionado';
                }
                this.tableLoading=false;
            })
            .catch(() => {
                this.tableLoading=false;
                this.tableNoDataText = 'No se encontraron preguntas para el índice seleccionado';
                });

      },

      //!Obtener listado de preguntas para seleccionar como pregunta superior al momento de crear una subpregunta
    async obtenerPreguntasSuperiores(){
      
       //this.tableLoading=true;
          this.preguntas=[];
            await this.$store
            .dispatch(OBTENER_PREGUNTAS, 0)
            .then(res => {
                //console.log(res)
                if(res.status===200){
                    this.preguntasSuperiores = res.data;
                } /*else {
                    //console.warn(res.message)
                    this.tableNoDataText = 'No se encontraron preguntas para el índice seleccionado';
                }*/
               // this.tableLoading=false;
            })
            .catch(() => {
                //this.tableLoading=false;
                this.tableNoDataText = 'No se encontraron preguntas para el índice seleccionado';
                });

    },


      //!Registrar 1/Actualizar 2 una pregunta
        async registrarItem(){
            //this.dialogLoaderVisible = true;
            //this.dialogLoaderText = 'Guardando información...';
            this.btnRegistroLoading=true;

            //!Asignar el estado a datos empresa segun lo seleccionado en el swithc del formulario
            this.switchItemEstado
                ? (this.datosPregunta.estadosId = 1)
                : (this.datosPregunta.estadosId = 2);

            //!Validar que sea una subpregunta para adjuntar la propiedad "preguntasId"
            if(this.subPregunta){
                this.datosPregunta.preguntasId = this.datosPregunta.preguntasId; 
            } else {
                delete this.datosPregunta.preguntasId;
            }

            //?Si accion es 1 se realiza el registro
            if(this.accion===1){        
                this.$store
                    .dispatch(REGISTRAR_PREGUNTA, this.datosPregunta)
                    .then(res => {
                        this.btnLoading=false;
                        if(res.status===200){
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.obtenerPreguntasPorIndice();
                            this.dialog=false;
                            this.resetForm();
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido un error durante el registro.`);
                        }
                        this.btnRegistroLoading=false;
                        
                    })
                    .catch(err => {
                        this.btnRegistroLoading=false;
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido en el proceso, por favor, ponte en contacto con un administrador del sistema. REF: ${err.lineNumber}`);
                    });
            } 
            //?Si accion es 2 se realiza la actualizacion
            else {
                this.$store
                    .dispatch(ACTUALIZAR_PREGUNTA, {datosPregunta: this.datosPregunta, id: this.datosPregunta.id} )
                    .then(res => {
                       
                        this.btnLoading=false;
                        this.dialogLoaderVisible = false;
                        this.btnRegistroLoading=false;
                        
                        if(res.status===200){
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.dialog=false;
                            this.obtenerPreguntasPorIndice();
                            this.resetForm();
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        
                        //console.log(this.datosInstitucion + res)
                    })
                    .catch(err => {
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido en el proceso, por favor, ponte en contacto con un administrador del sistema. REF: ${err.lineNumber}`);
                    });
            }
            
            
        },


      //!Obtener datos de una pregunta, tipo 1 pregunta, tipo 2 subpregunta (para deshabilitar los medios dee verificacion)
      async obtenerDatosPregunta(Id, tipo){
        
        this.dialogLoaderVisible=true;
        this.datosPregunta.id = Id;
        this.idPregunta=Id;
        this.accion=2;
        this.modalTitle='Actualizar Pregunta';
        this.btnRegistroText='Actualizar Pregunta';
        this.activeTab=0;
        if(tipo===1){
            this.tabMediosDisabled=false;
        } else{
           this.tabMediosDisabled=true; 
        }
        await this.$store
            .dispatch(OBTENER_PREGUNTA, Id)
            .then(res => {
                if(res.status===200){
                this.datosPregunta = this.$store.state.pregunta.pregunta;
                this.datosPregunta.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                this.dialog = true;     
                this.adminRespuestaKey +=1;
                this.adminMediosKey += 1;
                if(tipo===2){
                    this.subPregunta=true;
                } else {
                    this.subPregunta=false;
                }
                this.renderAdminRespuestas=true;
                } else{
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    
                }
                this.dialogLoaderVisible = false;
            })
            .catch(err => {
                this.dialogLoaderVisible = false;
                this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido en el proceso, por favor, ponte en contacto con un administrador del sistema. REF: ${err}`);
            });
      },

      //!Obtener los medios de verificación y mostrar modal para crear/editar
      async modalMediosVerificacion(Texto, Id){
          this.accion=2;
          this.activeTab=2;
          this.modalTitle= Texto + Id;
          this.dialog = true;  
      },

      modalRespuestas(Texto, Id){
          this.accion=2;
          this.modalTitle= Texto + Id;
          this.activeTab=1;
          this.dialog = true;

      },

      //!Obtener el listado de preguntas segun la pregunta seleccionada (subpreguntas)
      async obtenerSubPreguntasPorPreguntas(item){
          console.log(item.id)
          this.subpreguntas=[];
          let data = [];
          let self = this;  
          await this.$store
            .dispatch(OBTENER_SUB_PREGUNTAS_POR_PREGUNTA, item.id)
            .then(res => {
                //console.log(res)
                if(res.status===200){
                    
                    this.subpreguntas = res.data;
                    data.children = this.subpreguntas;
                    console.log(data)
                    item.children.push(...data);
                    self.open = item;
                } else {
                    console.warn(res.message)
                }
            })
            .catch(err => console.warn(err));
      },

      //!Agregar respuestas para la pregunta seleccionada
      agregarRespuesta(){
          this.dialogRes = true;
      },

      handleClick(row){
          
          console.log(row)
      },

      async fetchUsers (item) {
        // Remove in 6 months and say
        // you've made optimizations! :)
        await pause(1500)

        return fetch('https://jsonplaceholder.typicode.com/users')
          .then(res => res.json())
          .then(json => (item.children.push(...json)))
          .catch(err => console.warn(err))
      },
      randomAvatar () {
        this.avatar = avatars[Math.floor(Math.random() * avatars.length)]
      },

    //!Tipo 1: pregunta, Tipo 2: subpregunta
      modalNueva(tipo, itemId, institucionesId, indicesId){
        this.accion =1;
        this.modalTitle='Registrar Pregunta';
        this.btnRegistroText='Registrar Pregunta';
        this.switchItemEstado=true;

       // console.log(itemId)
       
        if(tipo===2){
            this.subPregunta=true;
            this.datosPregunta.preguntasId=itemId;
            this.datosPregunta.institucionesId = institucionesId;
            this.datosPregunta.indicesId = indicesId;

        }
        //console.log(this.subPregunta)
        this.dialog=true;

      },
    },
    created(){
        this.obtenerIndices();
        this.obtenerInstitucionesRevisoras();
        this.obtenerPreguntasSuperiores();
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Preguntas" }
        ]);
    },
    computed: {
        headers() {
            return [
                /*{
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },*/
                {
                    text: "Nombre Institución",
                    value: "nombre_Completo"
                },
                {
                    text: "Siglas",
                    value: "siglas"
                },
                {
                    text: "Usuario Máster",
                    value: "CorreoUsuario"
                },
                {
                    text: "Estado",
                    value: "estado"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        },

        
        items () {
            return [
            {
                name: 'Users',
                children: this.users,
            },
            ]
        },
        selected () {
            if (!this.active.length) return undefined

            const id = this.active[0]

            return this.users.find(user => user.id === id)
        },
    }
    
  }
</script>
<style lang="">
    
</style>